import { createSelector } from 'reselect';

import { StateType } from '../index';

export const alphaPropertiesReducerSelector = (state: StateType) => state.get('alphaProperties');

export const alphaPropertiesErrorColorSelector = (state: StateType) => state.getIn(['alphaProperties', 'errorcolor']);
export const alphaPropertiesErrorNameSelector = (state: StateType) => state.getIn(['alphaProperties', 'errorname']);
export const alphaPropertiesErrorTagsSelector = (state: StateType) => state.getIn(['alphaProperties', 'errortags']);
export const alphaPropertiesErrorCategorySelector = (state: StateType) => state.getIn(['alphaProperties', 'errorcategory']);
export const alphaPropertiesErrorOsmosisPointsSelector = (state: StateType) => state.getIn(['alphaProperties', 'errorosmosisPoints']);
export const alphaPropertiesErrorRegularSelector = (state: StateType) => state.getIn(['alphaProperties', 'regular', 'error']);
export const alphaPropertiesErrorComboSelector = (state: StateType) => state.getIn(['alphaProperties', 'combo', 'error']);
export const alphaPropertiesErrorSelectionSelector = (state: StateType) => state.getIn(['alphaProperties', 'selection', 'error']);

export const alphaPropertiesFieldOnFocusSelector = (state: StateType) => state.getIn(['alphaProperties', 'fieldOnFocus']);
export const alphaPropertiesTagsOptionsSelector = (state: StateType) => state.getIn(['alphaProperties', 'tagsOptions']);
export const shouldCheckSelector = (state: StateType) => state.getIn(['alphaProperties', 'shouldCheck']);
export const shouldSubmitSelector = (state: StateType) => state.getIn(['alphaProperties', 'shouldSubmit']);
export const getHasUpdatedPropertiesSelector = (state: StateType) => state.getIn(['alphaProperties', 'hasUpdatedProperties']);
export const alphaPropertiesShowErrorsSelector = (state: StateType) => state.getIn(['alphaProperties', 'showErrors']);
export const alphaPropertiesShouldScrollToSelector = (state: StateType) =>
  state.getIn(['alphaProperties', 'shouldScrollToAlphaProperties']);

export const alphaPropertiesColorSelector = (state: StateType) => state.getIn(['alphaProperties', 'color']);
export const alphaPropertiesNameSelector = (state: StateType) => state.getIn(['alphaProperties', 'name']);
export const alphaPropertiesOsmosisPointsSelector = (state: StateType) =>
  state.getIn(['alphaProperties', 'osmosisPoints']) as number | undefined;
export const alphaPropertiesTagsSelector = (state: StateType) => state.getIn(['alphaProperties', 'tags']);
export const alphaPropertiesCategorySelector = (state: StateType) => state.getIn(['alphaProperties', 'category']);
export const alphaPropertiesRegularDescriptionSelector = (state: StateType) => state.getIn(['alphaProperties', 'regular', 'description']);
export const alphaPropertiesSelectionDescriptionSelector = (state: StateType) =>
  state.getIn(['alphaProperties', 'selection', 'description']);
export const alphaPropertiesComboDescriptionSelector = (state: StateType) => state.getIn(['alphaProperties', 'combo', 'description']);

export const alphaPropertiesHasErrorsSelector = createSelector(
  alphaPropertiesErrorColorSelector,
  alphaPropertiesErrorNameSelector,
  alphaPropertiesErrorTagsSelector,
  alphaPropertiesErrorCategorySelector,
  alphaPropertiesErrorOsmosisPointsSelector,
  alphaPropertiesErrorRegularSelector,
  alphaPropertiesErrorComboSelector,
  alphaPropertiesErrorSelectionSelector,
  (errorColor, errorName, errorTags, errorCategory, errorOsmosisPoints, errorRegular, errorCombo, errorSelection) => {
    const errorList = [errorColor, errorName, errorTags, errorCategory, errorOsmosisPoints, errorRegular, errorCombo, errorSelection];
    let hasError = false;
    errorList.forEach(errors => {
      // @ts-ignore
      if (errors && errors.size > 0) {
        hasError = true;
      }
    });

    return hasError;
  }
);
